// Formatting helpers for the Target Group observability dashboard (BOF-65).

import type { MonthKey, Money } from "../../../../types/targetGroupAnalytics";

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/** "YYYY-MM" (zero-padded; lexicographically comparable). */
export const monthKeyToString = (m: MonthKey): string =>
  `${m.year}-${String(m.month).padStart(2, "0")}`;

/** Short axis/label form, e.g. "Jul '25". */
export const monthLabel = (m: MonthKey): string =>
  `${MONTHS[m.month - 1]} '${String(m.year).slice(-2)}`;

export const parseMonthKey = (s: string): MonthKey => {
  const [y, mm] = s.split("-");
  return { year: Number(y), month: Number(mm) };
};

export const formatMoney = (money: Money): string => {
  const amount = money.amount.toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return money.currency === "EUR" ? `€${amount}` : `${money.currency} ${amount}`;
};
